import { render, staticRenderFns } from "./FlashCardSheet.vue?vue&type=template&id=54266041&scoped=true&"
import script from "@/scripts/FlashCard/FlashCardDetail/components/FlashCardSheet?vue&type=script&lang=js&"
export * from "@/scripts/FlashCard/FlashCardDetail/components/FlashCardSheet?vue&type=script&lang=js&"
import style0 from "./FlashCardSheet.vue?vue&type=style&index=0&id=54266041&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54266041",
  null
  
)

export default component.exports